import { render, staticRenderFns } from "./processIcon.vue?vue&type=template&id=5d53755c&scoped=true&"
import script from "./processIcon.vue?vue&type=script&lang=js&"
export * from "./processIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d53755c",
  null
  
)

export default component.exports